import { CustomFieldDefinition } from '@/types';
import api from './client/axios';

export const getCustomFields = async (): Promise<any> => {
  const response = await api.get(`/custom-fields`);
  return response.data.customFields;
};

export const createCustomField = async (
  customField: Partial<CustomFieldDefinition>,
): Promise<any> => {
  const response = await api.post(`/custom-fields`, customField);
  return response.data.customFields;
};

export const updateCustomField = async (
  customField: Partial<CustomFieldDefinition>,
): Promise<any> => {
  const response = await api.patch(
    `/custom-fields/${customField.id}/update`,
    customField,
  );

  return response.data.customFields;
};
